import {
  DEFAULT_TOP_LEVEL_SURFACE,
  MAXIMUM_TOP_LEVEL_NUMBER
} from '../../../../../../constants/appConstants';

export const getCaseTopLevelsAutoCountFromRealBuiltSurface = (realBuiltSurface: number): number => {
  const autoTopLevelsCount = Math.max(1, Math.ceil(realBuiltSurface / DEFAULT_TOP_LEVEL_SURFACE));
  return Math.min(MAXIMUM_TOP_LEVEL_NUMBER, autoTopLevelsCount);
};
